import { SvgIcon } from '@progress/kendo-react-common';
import { EditOutline, PlusOutline, TrashOutline } from '../../../icons/icons';
import { AiAppliedChanges, AiChangeKind, buildChangeItems } from './ai-chat-helpers';

const KIND_META: Record<AiChangeKind, { icon: typeof PlusOutline; label: string }> = {
    added: { icon: PlusOutline, label: 'Added' },
    updated: { icon: EditOutline, label: 'Updated' },
    removed: { icon: TrashOutline, label: 'Removed' }
};

export function AiChangeSummary(props: { changes: AiAppliedChanges; reverted?: boolean }) {
    const items = buildChangeItems(props.changes);
    return (
        <div className={`ai-chat-changes ${props.reverted ? 'ai-chat-changes-reverted' : ''}`}>
            {items.map((item, i) => {
                const meta = KIND_META[item.kind];
                return (
                    <div key={i} className="ai-chat-change-row d-flex align-items-center gap-2">
                        <span className={`ai-chat-change-icon ai-chat-change-${item.kind}`} title={meta.label}>
                            <SvgIcon icon={meta.icon} size="small" />
                        </span>
                        <span className="ai-chat-change-swatch" style={{ background: item.color }} />
                        <span className="ai-chat-change-name">{item.name}</span>
                        <span className="secondary-text-color ai-chat-change-label">{meta.label}</span>
                    </div>
                );
            })}
        </div>
    );
}
